import React, { useState } from 'react';
import './Chatbot.scss';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChatbotClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="chatbot-container">
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <div className="chatbot-header-left">
              <div className="chatbot-avatar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 13.54 2.35 14.99 2.97 16.28L2 22L7.72 21.03C9.01 21.65 10.46 22 12 22C17.52 22 22 17.52 22 12S17.52 2 12 2ZM12 20C10.74 20 9.54 19.81 8.44 19.46L8 19.25L5.5 20L6.75 17.5L6.54 17.06C6.19 15.96 6 14.76 6 13.5C6 8.25 8.25 6 13.5 6S21 8.25 21 13.5S18.75 21 13.5 21H12Z" fill="white"/>
                  <circle cx="8.5" cy="12" r="1.5" fill="white"/>
                  <circle cx="15.5" cy="12" r="1.5" fill="white"/>
                </svg>
              </div>
              <div className="chatbot-title-section">
                <span className="chatbot-title">AI Assistant</span>
                <div className="connection-status connected">
                  Live Chat
                </div>
              </div>
            </div>
            <button className="chatbot-minimize" onClick={() => setIsOpen(false)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 13H5V11H19V13Z" fill="white"/>
              </svg>
            </button>
          </div>
          
          <div className="chatbot-iframe-container">
            <iframe
              src="https://dev.ai.showdigital.in/africa/"
              title="AI Chatbot"
              className="chatbot-iframe"
              allow="microphone; camera"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
            />
          </div>
        </div>
      )}
      
      <button 
        className="chatbot-button"
        onClick={handleChatbotClick}
        aria-label="Open Chatbot"
        title="Chat with our AI Assistant"
      >
        <div className="chatbot-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 13.54 2.35 14.99 2.97 16.28L2 22L7.72 21.03C9.01 21.65 10.46 22 12 22C17.52 22 22 17.52 22 12S17.52 2 12 2ZM12 20C10.74 20 9.54 19.81 8.44 19.46L8 19.25L5.5 20L6.75 17.5L6.54 17.06C6.19 15.96 6 14.76 6 13.5C6 8.25 8.25 6 13.5 6S21 8.25 21 13.5S18.75 21 13.5 21H12Z" fill="currentColor"/>
            <circle cx="8.5" cy="12" r="1.5" fill="currentColor"/>
            <circle cx="15.5" cy="12" r="1.5" fill="currentColor"/>
          </svg>
        </div>
        <div className="chatbot-pulse"></div>
      </button>
    </div>
  );
};

export default Chatbot;
